/**
 * Announces product-grid replacements caused by collection filters and sorting.
 * The theme swaps [data-products-grid] via AJAX, so visual changes otherwise
 * have no screen-reader feedback (WCAG 4.1.3).
 */
(function () {
  'use strict';

  function createLiveRegion() {
    var region = document.createElement('div');
    region.className = 'visually-hidden';
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    region.setAttribute('data-collection-results-status', '');
    document.body.appendChild(region);
    return region;
  }

  function productCount(grid) {
    return grid.querySelectorAll('.product-item:not(.product-item--featured-image)').length;
  }

  var watchedGrids = new WeakSet();
  var region = null;

  // Search renders separate grids (Products / Pages / Blogs) and a re-render
  // can swap a grid element out entirely, so every [data-products-grid] gets
  // its own observer and baseline count, including grids added later.
  function watchGrid(grid) {
    if (watchedGrids.has(grid)) return;
    watchedGrids.add(grid);
    // Created with the first grid (not at announce time) so the live region
    // already exists before its text changes, and pages with no grid get none.
    region = region || document.querySelector('[data-collection-results-status]') || createLiveRegion();

    var lastCount = productCount(grid);
    var timer;

    new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        if (!grid.isConnected) return;
        var count = productCount(grid);
        if (count === lastCount && !grid.querySelector('.no-results')) return;
        lastCount = count;
        region.textContent = count === 1 ? '1 product shown' : count + ' products shown';
      }, 150);
    }).observe(grid, { childList: true, subtree: true });
  }

  function scanForGrids() {
    document.querySelectorAll('[data-products-grid]').forEach(watchGrid);
  }

  function init() {
    scanForGrids();

    var scanTimer;
    new MutationObserver(function () {
      window.clearTimeout(scanTimer);
      scanTimer = window.setTimeout(scanForGrids, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
